/* Baesics Probador Virtual — v1.2 (fit por línea: compresión 3, boxy 2, bottoms sin fit)
 * Recomendación de talle por producto + atleta de referencia + add to cart.
 * Config se lee de window.BaesicsProbador (inyectado por el snippet Liquid).
 */
(function () {
  'use strict';

  var NUMERIC_MAP = { XS: '0', S: '1', M: '2', L: '3', XL: '4', XXL: '5' };

  /* ---------- Tablas por defecto (cm / kg) — se pisan por metafield ---------- */
  var DEFAULT_TABLES = {
    compressive: {
      note: 'Esta prenda es compresiva. Si estás entre dos talles, quedate en el más chico.',
      sizes: [
        { size: 'S',  height: [160, 172], weight: [55, 68] },
        { size: 'M',  height: [168, 180], weight: [66, 80] },
        { size: 'L',  height: [176, 188], weight: [78, 92] },
        { size: 'XL', height: [184, 196], weight: [90, 106] }
      ]
    },
    regular: {
      note: 'Calce regular. Si estás entre dos talles, elegí según cómo te guste usarla.',
      sizes: [
        { size: 'S',  height: [160, 172], weight: [55, 70] },
        { size: 'M',  height: [168, 182], weight: [68, 84] },
        { size: 'L',  height: [176, 190], weight: [82, 96] },
        { size: 'XL', height: [184, 198], weight: [94, 112] }
      ]
    },
    fem: {
      note: 'Calce ajustado femenino. Si estás entre dos talles, elegí el más chico para más compresión o el más grande para más comodidad.',
      sizes: [
        { size: 'XS', height: [150, 162], weight: [42, 52] },
        { size: 'S',  height: [156, 168], weight: [50, 60] },
        { size: 'M',  height: [162, 174], weight: [58, 70] },
        { size: 'L',  height: [168, 180], weight: [68, 82] },
        { size: 'XL', height: [172, 186], weight: [80, 96] }
      ]
    },
    boxy: {
      note: 'Corte boxy: ya viene holgada. Si estás entre dos talles, quedate en el más chico.',
      sizes: [
        { size: 'S',  height: [160, 174], weight: [55, 72] },
        { size: 'M',  height: [170, 184], weight: [70, 88] },
        { size: 'L',  height: [178, 192], weight: [86, 102] },
        { size: 'XL', height: [186, 200], weight: [100, 118] }
      ]
    }
  };

  /* ---------- Motor de recomendación ---------- */
  function mid(r) { return (r[0] + r[1]) / 2; }
  function span(r) { return (r[1] - r[0]) / 2; }

  // distancia normalizada al centro del rango (0 = centro, 1 = borde, >1 afuera)
  function dist(v, range) { return Math.abs(v - mid(range)) / span(range); }

  function recommend(input, table) {
    var sizes = table.sizes;
    var scored = sizes.map(function (s) {
      var dh = dist(input.height, s.height);
      var dw = dist(input.weight, s.weight);
      // el peso pesa más que la altura en prendas superiores
      var score = dh * 0.4 + dw * 0.6;
      return { size: s.size, score: score };
    }).sort(function (a, b) { return a.score - b.score; });

    var best = scored[0];
    var idx = sizes.findIndex(function (s) { return s.size === best.size; });

    // ajuste por contextura: ancha suma medio talle, delgada resta medio talle
    var shift = 0;
    if (input.build === 'wide') shift += 0.5;
    if (input.build === 'slim') shift -= 0.5;

    // ajuste por preferencia de calce según tipo de prenda
    var fitType = table.fit_type || 'regular';
    var isVangardeFit = cfg && /^Vangarde Seamless$/i.test((cfg.product || '').trim());
    // En Vangarde, "Compression" busca un talle más ceñido que el talle base.
    if (isVangardeFit && input.fit === 'regular') shift -= 1;
    if (input.fit === 'loose') shift += isVangardeFit ? 0.5 : 1; // Vangarde: más suelta mantiene el talle base salvo contextura
    if (input.fit === 'tight') shift -= fitType === 'compressive' ? 0 : 0.5;

    // solo se mueve un talle si los ajustes suman un paso entero; nunca más de 1
    var step = Math.abs(shift) >= 1 ? (shift > 0 ? 1 : -1) : 0;
    var finalIdx = Math.min(sizes.length - 1, Math.max(0, idx + step));

    // confianza: margen entre los dos mejores + si el usuario cae dentro del rango
    var margin = scored.length > 1 ? scored[1].score - scored[0].score : 1;
    var inside = best.score <= 1;
    var confidence = (inside && margin > 0.35) ? 'high' : (inside || margin > 0.2) ? 'medium' : 'low';
    // si hubo medio ajuste sin llegar a cambiar de talle, o cambió de talle, bajar un escalón
    if (shift !== 0 && confidence === 'high') confidence = 'medium';

    // talle alternativo para el mensaje "si estás entre X e Y"
    var altIdx = finalIdx + (shift > 0 ? -1 : 1);
    var alt = sizes[altIdx] ? sizes[altIdx].size : null;

    return {
      size: sizes[finalIdx].size,
      alt: alt,
      confidence: confidence,
      matches: 0,
      note: table.note || ''
    };
  }

  /* ---------- Motor por referencias reales (personas) ---------- */
  function refDistance(input, r) {
    return Math.sqrt(Math.pow((input.height - r.height) / 7, 2) + Math.pow((input.weight - r.weight) / 6, 2));
  }
  function recommendFromRefs(input, refs, order, fitType) {
    var valid = refs.filter(function (r) { return order.indexOf(r.size) >= 0; });
    if (!valid.length) return null;
    var scored = valid.map(function (r) { return { ref: r, d: refDistance(input, r) }; })
      .sort(function (a, b) { return a.d - b.d; });
    var nearest = scored[0];

    // 1) estimación por vecinos: pesos fuertes por cercanía, máx 3, y sólo los que están a distancia comparable
    var k = Math.min(3, scored.length);
    var sumW = 0, sumIdx = 0, used = [];
    for (var i = 0; i < k; i++) {
      if (i > 0 && scored[i].d > nearest.d * 2.2 + 0.6) break;
      var w = 1 / Math.pow(0.25 + scored[i].d, 2);
      sumW += w; sumIdx += w * order.indexOf(scored[i].ref.size); used.push(scored[i]);
    }
    var est = sumIdx / sumW;

    // 2) extrapolación en los extremos: si el cliente es más chico/grande que TODAS las referencias
    var minH = Infinity, maxH = -Infinity, minW = Infinity, maxW = -Infinity, minIdx = Infinity, maxIdx = -Infinity;
    valid.forEach(function (r) {
      minH = Math.min(minH, r.height); maxH = Math.max(maxH, r.height);
      minW = Math.min(minW, r.weight); maxW = Math.max(maxW, r.weight);
      var ix = order.indexOf(r.size); minIdx = Math.min(minIdx, ix); maxIdx = Math.max(maxIdx, ix);
    });
    var extrapolated = false;
    if (input.height < minH && input.weight < minW) {
      var gapDown = Math.max((minH - input.height) / 8, (minW - input.weight) / 7);
      est = minIdx - (gapDown >= 1 ? 1 : 0); extrapolated = true;
    } else if (input.height > maxH && input.weight > maxW) {
      var gapUp = Math.max((input.height - maxH) / 8, (input.weight - maxW) / 7);
      est = maxIdx + (gapUp >= 1 ? 1 : 0); extrapolated = true;
    } else if (input.weight < minW) {
      est = Math.min(est, minIdx); // más liviano que todos: nunca por encima del talle más chico referenciado
    } else if (input.weight > maxW) {
      est = Math.max(est, maxIdx);
    }

    // 3) ajustes del cliente
    var shift = 0;
    if (input.build === 'wide') shift += 0.35;
    if (input.build === 'slim') shift -= 0.35;
    var isVangardeFit = cfg && /^Vangarde Seamless$/i.test((cfg.product || '').trim());
    if (isVangardeFit && input.fit === 'regular') shift -= 1;
    if (input.fit === 'loose') shift += isVangardeFit ? 0.5 : (fitType === 'boxy' ? 1 : 0.75); // Vangarde: no fuerza salto de talle
    if (input.fit === 'tight') shift -= fitType === 'compressive' ? 0.25 : 0.5;
    est += shift;

    var idx = Math.min(order.length - 1, Math.max(0, Math.round(est)));
    var agree = used.every(function (x) { return x.ref.size === order[idx]; });
    var matches = used.filter(function (x) { return x.ref.size === order[idx]; }).length;
    var confidence = (nearest.d < 1.2 && agree && !extrapolated) ? 'high' : (nearest.d < 2.4) ? 'medium' : 'low';
    var frac = Math.abs(est - Math.round(est));
    if (frac > 0.35 && confidence === 'high') confidence = 'medium';
    var altIdx = est > idx ? idx + 1 : idx - 1;
    return {
      size: order[idx],
      alt: order[altIdx] || null,
      confidence: confidence,
      nearest: nearest.ref,
      matches: matches,
      borderline: frac > 0.35
    };
  }

  /* ---------- Atleta de referencia ---------- */
  function closestAthlete(input, athletes, size) {
    if (!athletes || !athletes.length) return null;
    var buildRank = { slim: 0, medium: 1, wide: 2 };
    var best = null, bestD = Infinity;
    athletes.forEach(function (a) {
      var d = Math.abs(a.height - input.height) / 10
            + Math.abs(a.weight - input.weight) / 8
            + Math.abs((buildRank[a.build] || 1) - (buildRank[input.build] || 1)) * 1.5;
      if (a.sizes && a.sizes[size] === undefined && a.size !== size) d += 2; // no usa ese talle
      if (d < bestD) { bestD = d; best = a; }
    });
    return best;
  }

  /* ---------- Variantes (respeta color elegido) ---------- */
  function currentOther() {
    var id = null;
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) id = m[1];
    if (!id) { var inp = document.querySelector('form[action*="/cart/add"] [name="id"]'); if (inp) id = inp.value; }
    var v = cfg.variantList.filter(function (x) { return String(x.id) === String(id); })[0];
    return v ? v.other : null;
  }
  function variantFor(size) {
    var other = currentOther();
    var same = cfg.variantList.filter(function (v) { return v.size === size; });
    if (!same.length) return null;
    var match = other !== null ? same.filter(function (v) { return v.other === other; })[0] : null;
    return match || same.filter(function (v) { return v.available; })[0] || same[0];
  }
  function buildVariantIndex() {
    cfg.variants = {};
    cfg.variantList.forEach(function (v) {
      if (!cfg.variants[v.size]) cfg.variants[v.size] = { id: v.id, available: false };
      if (v.available) cfg.variants[v.size].available = true;
    });
  }

  /* ---------- UI ---------- */
  var cfg, root, state;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function buildLabel(b) { return { slim: 'delgada', medium: 'media', wide: 'ancha' }[b] || b; }

  function render(rec, athlete) {
    var res = $('[data-pb-result]');
    var sizeEl = $('[data-pb-size]');
    sizeEl.textContent = rec.size;
    sizeEl.style.animation = 'none'; void sizeEl.offsetWidth; sizeEl.style.animation = '';

    $('[data-pb-summary]').textContent = state.input.height + ' cm · ' + state.input.weight + ' kg · editar';

    var conf = $('[data-pb-confidence]');
    conf.dataset.level = rec.confidence;
    var matches = rec.matches || 0;
    conf.textContent = rec.confidence === 'high'
      ? (matches > 1 ? 'Coincide con ' + matches + ' referencias' : 'Coincide con tu referencia más cercana')
      : rec.confidence === 'medium' ? 'Entre dos talles, te recomendamos ' + rec.size : 'Pocas referencias parecidas a vos';

    // chips de talles
    var strip = $('[data-pb-sizes]');
    strip.innerHTML = '';
    cfg.table.sizes.forEach(function (s) {
      var v = variantFor(s.size);
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'pb-size';
      if (s.size === rec.size) el.classList.add('is-pick');
      if (v && !v.available) el.classList.add('is-out');
      el.textContent = s.size;
      el.setAttribute('aria-label', 'Elegir talle ' + s.size);
      el.addEventListener('click', function () {
        if (!v || !v.available) return;
        var r2 = Object.assign({}, state.rec, { size: s.size, alt: state.rec.size !== s.size ? state.rec.size : state.rec.alt, manual: true });
        render(r2, state.athlete);
      });
      strip.appendChild(el);
    });

    // nota
    var note = rec.note || '';
    if (rec.alt && (rec.borderline || rec.confidence !== 'high') && !/entre dos talles/i.test(note)) {
      note += ' Entre ' + rec.alt + ' y ' + rec.size + ', ' + (cfg.table.fit_type === 'regular' ? 'te recomendamos ' : 'quedate en ') + rec.size + '.';
    }
    $('[data-pb-note]').textContent = note;

    // atleta
    var athBox = $('[data-pb-athlete]');
    if (athlete) {
      athBox.hidden = false;
      var athSize = (athlete.sizes && athlete.sizes[cfg.table.fit_type]) || athlete.size || rec.size;
      if (cfg.numeric && NUMERIC_MAP[athSize]) athSize = NUMERIC_MAP[athSize];
      if (athlete.image) $('[data-pb-ath-img]').src = athlete.image; else $('[data-pb-ath-img]').removeAttribute('src');
      $('[data-pb-ath-img]').alt = athlete.name;
      $('[data-pb-ath-img]').hidden = !athlete.image;
      var parts = athlete.name.trim().split(/\s+/);
      $('[data-pb-ath-initials]').textContent = (parts.length > 1 ? parts[0][0] + parts[1][0] : athlete.name.slice(0, 2)).toUpperCase();
      $('[data-pb-ath-initials]').hidden = !!athlete.image;
      $('[data-pb-ath-name]').textContent = athlete.name + ' usa ' + athSize;
      $('[data-pb-ath-meta]').textContent = (athlete.height / 100).toFixed(2).replace('.', ',') + ' m · ' + athlete.weight + ' kg' + (athlete.build ? ' · contextura ' + buildLabel(athlete.build) : ' · la referencia más parecida a vos');
    } else {
      athBox.hidden = true;
    }

    // producto sin stock en ningún talle
    var anyStock = cfg.table.sizes.some(function (s) { var vv = variantFor(s.size); return vv && vv.available; });
    $('[data-pb-soldout]').hidden = anyStock;
    if (!anyStock) { conf.textContent = 'Sin stock'; conf.dataset.level = 'low'; }

    // CTA
    var v = variantFor(rec.size);
    var btn = $('[data-pb-add]');
    var altBtn = $('[data-pb-add-alt]');
    var notify = $('[data-pb-notify]');
    var other = currentOther();
    var colorTxt = other ? ' · ' + other.split('|').filter(Boolean).join(' / ') : '';
    altBtn.hidden = true;
    if (v && v.available) {
      btn.hidden = false; notify.hidden = true;
      btn.textContent = 'Agregar ' + rec.size + colorTxt + ' al carrito';
      btn.dataset.variantId = v.id;
      btn.dataset.size = rec.size;
      var va = rec.alt ? variantFor(rec.alt) : null;
      if (va && va.available && (rec.borderline || rec.confidence !== 'high' || rec.manual)) {
        var order0 = cfg.table.sizes.map(function (s) { return s.size; });
        var up = order0.indexOf(rec.alt) > order0.indexOf(rec.size);
        var dir = cfg.isBottom ? (up ? 'más grande' : 'más chico') : cfg.table.fit_type === 'boxy' ? (up ? 'over' : 'boxy') : (up ? 'más suelta' : 'más ajustada');
        altBtn.hidden = false;
        altBtn.textContent = 'Prefiero ' + rec.alt + ' (' + dir + ')';
        altBtn.dataset.variantId = va.id;
        altBtn.dataset.size = rec.alt;
      }
    } else {
      btn.hidden = true; notify.hidden = false;
      // sugerir el más cercano disponible
      var order = cfg.table.sizes.map(function (s) { return s.size; });
      var i = order.indexOf(rec.size);
      var near = [order[i + 1], order[i - 1], order[i + 2], order[i - 2]].filter(function (s) { var vv = s && variantFor(s); return vv && vv.available; })[0];
      $('[data-pb-notify-text]').textContent = anyStock
        ? (rec.size + ' está agotado.' + (near ? ' El más cercano disponible es ' + near + '.' : '') + ' Dejanos tu mail y te avisamos cuando vuelva.')
        : ('Este producto está agotado en todos los talles. Dejanos tu mail y te avisamos cuando vuelva tu talle ' + rec.size + '.');
      $('[data-pb-notify-size]').value = rec.size;
    }

    state.rec = rec;
    state.athlete = athlete;
    showResult();
  }

  function readNum(el) {
    if (!el) return NaN;
    var v = (el.value !== undefined && el.value !== '') ? el.value : el.getAttribute('value');
    if ((v === null || v === '') && typeof el.valueAsNumber === 'number' && !isNaN(el.valueAsNumber)) return el.valueAsNumber;
    return parseInt(String(v || '').replace(',', '.'), 10);
  }

  function readInput() {
    var h = readNum($('[data-pb-height]'));
    var w = readNum($('[data-pb-weight]'));
    var build = ($('[data-pb-build].is-on') || {}).dataset || {};
    var fit = ($('[data-pb-fit].is-on') || {}).dataset || {};
    var err = $('[data-pb-error]');
    err.textContent = '';
    if (!h || h < 140 || h > 215) { err.textContent = 'Ingresá tu altura en centímetros (140–215).'; return null; }
    if (!w || w < 40 || w > 160) { err.textContent = 'Ingresá tu peso en kilos (40–160).'; return null; }
    return { height: h, weight: w, build: build.value || 'medium', fit: cfg.isBottom ? 'regular' : (fit.value || 'regular') };
  }

  function calc() {
    var input = readInput();
    if (!input) return;
    var rec, ath;
    var order = cfg.table.sizes.map(function (s) { return s.size; });
    if (cfg.refs && cfg.refs.length) {
      rec = recommendFromRefs(input, cfg.refs, order, cfg.table.fit_type);
      if (rec) {
        rec.note = cfg.table.note || '';
        var n = rec.nearest;
        ath = { name: n.name, height: n.height, weight: n.weight, build: null, size: n.size, image: n.image || '', real: true };
      }
    }
    if (!rec) {
      rec = recommend(input, cfg.table);
      ath = closestAthlete(input, cfg.athletes, rec.size);
    }

    // Regla de largo para pantalones: desde 185 cm, XL es el talle mínimo si existe.
    var isLongBottom = cfg.isBottom && /pant|jog|cargo|calza|legging|track/i.test(cfg.product || '') && !/short|bermuda/i.test(cfg.product || '');
    if (isLongBottom && input.height >= 185) {
      var xlIdx = order.indexOf('XL');
      var currentIdx = order.indexOf(rec.size);
      if (xlIdx >= 0 && currentIdx >= 0 && currentIdx < xlIdx) {
        var previousSize = rec.size;
        rec.size = 'XL';
        rec.alt = previousSize;
        rec.confidence = 'medium';
        rec.borderline = true;
        rec.note = (rec.note ? rec.note + ' ' : '') + 'Por tu altura, priorizamos el largo: desde 185 cm recomendamos XL como mínimo.';
        ath = closestAthlete(input, cfg.athletes, rec.size) || ath;
      }
    }

    state.input = input;
    render(rec, ath);
    try { localStorage.setItem('baesics_probador', JSON.stringify(input)); } catch (e) {}
  }

  function addToCart(variantId, size) {
    var btn = $('[data-pb-add]');
    btn.disabled = true; btn.textContent = 'Agregando…';

    // mismos section ids que usa el product-form de Horizon para refrescar el cart drawer
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    fd.append('properties[_probador_talle]', size);
    fd.append('properties[_probador_altura]', state.input.height);
    fd.append('properties[_probador_peso]', state.input.weight);
    fd.append('properties[_probador_contextura]', state.input.build);
    fd.append('properties[_probador_calce]', state.input.fit);
    fd.append('properties[_probador_confianza]', state.rec.confidence);
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
    fetch(addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'cart');
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = { resource: cart, sourceId: 'probador', data: { source: 'probador', itemCount: 1, variantId: String(variantId), sections: res.sections || {} } };
          document.dispatchEvent(ev);
          btn.textContent = 'Agregado';
          close();
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) drawer.open();
          if (!drawer) setTimeout(function () { window.location.href = '/cart'; }, 400);
          setTimeout(function () { btn.disabled = false; btn.textContent = 'Agregar ' + size + ' al carrito'; }, 1500);
        });
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Agregar ' + size + ' al carrito';
        $('[data-pb-error]').textContent = 'No pudimos agregarlo. Probá de nuevo.';
      });
  }

  function showForm() { $('[data-pb-form]').hidden = false; $('[data-pb-result]').hidden = true; $('[data-pb-height]').focus(); }
  function showResult() { $('[data-pb-form]').hidden = true; $('[data-pb-result]').hidden = false; root.querySelector('.pb__panel').scrollTop = 0; }
  function open() { root.hidden = false; document.body.classList.add('pb-open'); if (!state.rec) showForm(); }
  function close() { root.hidden = true; document.body.classList.remove('pb-open'); }

  function toggleGroup(sel, el) {
    $$(sel).forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
    el.classList.add('is-on'); el.setAttribute('aria-pressed', 'true');
  }

  function init() {
    cfg = window.BaesicsProbador;
    root = document.querySelector('[data-probador]');
    if (!cfg || !root) return;
    if (root.dataset.pbReady) return;
    root.dataset.pbReady = '1';
    if (root.parentElement !== document.body) document.body.appendChild(root);
    state = {};

    // tabla: metafield del producto > tipo de calce > regular
    var hasRefs = cfg.table && cfg.table.refs && cfg.table.refs.length;
    if (!hasRefs && (!cfg.table || !cfg.table.sizes || !cfg.table.sizes.length)) {
      var t = DEFAULT_TABLES[cfg.fit_type] || DEFAULT_TABLES.regular;
      cfg.table = { fit_type: cfg.fit_type || 'regular', note: t.note, sizes: JSON.parse(JSON.stringify(t.sizes)) };
    }
    if (!cfg.table.fit_type) cfg.table.fit_type = cfg.fit_type || 'regular';
    if (!cfg.table.sizes) cfg.table.sizes = [];

    cfg.refs = (cfg.table && cfg.table.refs) || [];
    // si hay referencias reales, la lista de talles sale de las variantes (orden natural)
    if (cfg.refs.length) {
      var ORDER = ['XS','S','M','L','XL','XXL','0','1','2','3','4','5'];
      var seen = {};
      var sizesFromVariants = cfg.variantList.map(function (v) { return v.size; })
        .filter(function (x) { if (seen[x]) return false; seen[x] = true; return true; })
        .sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });
      cfg.table.sizes = sizesFromVariants.map(function (x) { return { size: x }; });
      var t2 = DEFAULT_TABLES[cfg.table.fit_type || cfg.fit_type] || DEFAULT_TABLES.regular;
      if (!cfg.table.note) cfg.table.note = t2.note;
    }

    // si las variantes son numéricas (1/2/3/4) mapear la tabla
    var numeric = cfg.variantList.every(function (v) { return /^\d+$/.test(v.size); });
    cfg.numeric = numeric;
    if (numeric && !cfg.refs.length) cfg.table.sizes.forEach(function (s) { s.size = NUMERIC_MAP[s.size] || s.size; });
    buildVariantIndex();
    // filtrar talles de la tabla que no existen como variante
    cfg.table.sizes = cfg.table.sizes.filter(function (s) { return cfg.variants[s.size]; });

    // vocabulario de calce según el tipo de prenda
    // boxy solo tiene dos opciones (Boxy / Over); las líneas sin 'tight' ocultan ese chip
    var FIT_LABELS = {
      boxy:        { regular: 'Boxy', loose: 'Over' },
      compressive: { tight: 'Ajustado', regular: 'Normal', loose: 'Más suelta' },
      fem:         { tight: 'Más compresión', regular: 'Fiel al talle', loose: 'Más cómoda' },
      regular:     { tight: 'Ajustada', regular: 'Como viene', loose: 'Más suelta' }
    };
    var isVangarde = /^Vangarde Seamless$/i.test((cfg.product || '').trim());
    // pantalones / shorts: sin paso de fit, se recomienda directo el talle ideal
    var isBottom = cfg.fit_type === 'bottom' || /pant|jog|short|bermuda|cargo|calza|legging/i.test(cfg.product || '');
    cfg.isBottom = isBottom;
    var labels = isVangarde
      ? { regular: 'Compression', loose: 'Más suelta' }
      : (FIT_LABELS[cfg.table.fit_type] || FIT_LABELS.regular);
    $$('[data-pb-fit]').forEach(function (b) {
      var l = labels[b.dataset.value];
      if (!l) { b.hidden = true; b.style.display = 'none'; b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); }
      else { b.hidden = false; b.style.display = ''; b.textContent = l; }
    });
    var fitStep = $('[data-pb-fit]') && $('[data-pb-fit]').parentElement.previousElementSibling;
    if (fitStep && fitStep.classList.contains('pb__step')) fitStep.innerHTML = '<i>3</i>Fit';
    if (isBottom) {
      var chipsBox = $('[data-pb-fit]') && $('[data-pb-fit]').parentElement;
      if (fitStep) fitStep.style.display = 'none';
      if (chipsBox) chipsBox.style.display = 'none';
    }
    function ensureFit() {
      var on = $('[data-pb-fit].is-on');
      if (!on || on.hidden) { var d = $('[data-pb-fit][data-value="regular"]'); if (d) toggleGroup('[data-pb-fit]', d); }
    }
    ensureFit();
    var hint = $('[data-pb-hint]');
    if (hint) hint.textContent = cfg.refs.length
      ? 'Recomendación basada en ' + cfg.refs.length + ' persona' + (cfg.refs.length > 1 ? 's reales que usan' : ' real que usa') + ' esta prenda'
      : 'Recomendación según el calce de esta prenda';

    $('[data-pb-edit]').addEventListener('click', function () { showForm(); });
    $('[data-pb-add-alt]').addEventListener('click', function () { addToCart(this.dataset.variantId, this.dataset.size); });

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-pb-open]');
      if (t) { e.preventDefault(); open(); }
    });
    $$('[data-pb-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    $$('[data-pb-build]').forEach(function (b) { b.addEventListener('click', function () { toggleGroup('[data-pb-build]', b); if (state.rec) calc(); }); });
    $$('[data-pb-fit]').forEach(function (b) { b.addEventListener('click', function () { toggleGroup('[data-pb-fit]', b); if (state.rec) calc(); }); });
    $('[data-pb-calc]').addEventListener('click', calc);
    ['[data-pb-height]', '[data-pb-weight]'].forEach(function (s) {
      $(s).addEventListener('input', function () { $('[data-pb-error]').textContent = ''; });
      $(s).addEventListener('keydown', function (e) { if (e.key === 'Enter') calc(); });
    });
    $('[data-pb-add]').addEventListener('click', function () { addToCart(this.dataset.variantId, this.dataset.size); });

    // recordar datos de la última vez
    try {
      var saved = JSON.parse(localStorage.getItem('baesics_probador') || 'null');
      if (saved) {
        $('[data-pb-height]').value = saved.height;
        $('[data-pb-weight]').value = saved.weight;
        var b = $('[data-pb-build][data-value="' + saved.build + '"]'); if (b) toggleGroup('[data-pb-build]', b);
        var f = $('[data-pb-fit][data-value="' + saved.fit + '"]'); if (f && !f.hidden) toggleGroup('[data-pb-fit]', f);
      }
    } catch (e) {}
    ensureFit();

    // auto-abrir si viene de la página /pages/probador con ?probador=1
    if (/[?&]probador=1/.test(location.search)) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
